var CONST = CONST || {};

//CONST.contentServerUrl = "http://fileserver.o2school.co.kr";

//CONST.contentServerUrl = "https://bj-dev.o2brain.co.kr";
//CONST.contentServerUrl = "https://bj-alpha.o2brain.co.kr";
CONST.contentServerUrl = "https://www.bj-sup.kr";
CONST.iniPayMobileServerUrl = "https://mobile.inicis.com";
CONST.iniPayWebServerUrl = "https://stdpay.inicis.com";
CONST.daumMapServerUrl = "https://ssl.daumcdn.net";
CONST.contentRoot = "websvr/contents";  
CONST.lectureContentRoot = "common/lecture";

CONST.CONTINUE_CATCH = "CONTINUE-CATCH";
CONST.COMPLETE_CATCH = "COMPLETE_CATCH";

// matchbook MAX PAGE NO
CONST.maxMatchBookPageNo = 99999;

//inicis 상점 ID
//CONST.iniPayMid = "studyqnet0";
//inicis 상점 TEST ID
//CONST.iniPayMid = "INIpayTest";
//inicis WEB용 인증키
//CONST.iniPaySignKey = "NFUwYTVmdEZ6NkV6Ui9BcjBaU2lrdz09";
//inicis WEB용 테스트인증키
//CONST.iniPaySignKey = "SU5JTElURV9UUklQTEVERVNfS0VZU1RS";

// code prefix
CONST.matchBookCodePrefix = "B";
CONST.matchPaperCodePrefix = "P";
CONST.examSetCodePrefix = "E";
CONST.smartBookCodePrefix = "S";
CONST.pqatCodePrefix = "Q";
CONST.diagCodePreFix = "D";
CONST.linkExamCodePrefix = "N";
CONST.lectureCodePrefix = "L";
CONST.userCodePrefix = "U";


// ResultCode map
CONST.resultCode = {};
CONST.resultCode.OK = "OK";
CONST.resultCode.HTTPERR_400 = "HTTPERROR_400";
CONST.resultCode.HTTPERR_403 = "HTTPERROR_403";
CONST.resultCode.HTTPERR_404 = "HTTPERROR_404";
CONST.resultCode.HTTPERR_500 = "HTTPERROR_500";
CONST.resultCode.HTTPERR_ETC = "HTTPERROR_ETC";
CONST.resultCode.EXCEPTION = "EXCEPTION";
CONST.resultCode.ERROR = "ERROR";
CONST.resultCode.FAIL = "FAIL";
CONST.resultCode.LOCKED = "LOCKED";
CONST.resultCode.TOKEN_EXPIRED = "TOKEN_EXPIRED";
CONST.resultCode.TOKEN_MISMATCH = "TOKEN_MISMATCH";
CONST.resultCode.EXPIRED = "EXPIRED";
CONST.resultCode.USER_AUTH_EXPIRED = "USER_AUTH_EXPIRED";
CONST.resultCode.COMPANY_AUTH_EXPIRED = "COMPANY_AUTH_EXPIRED";
CONST.resultCode.FORBIDDEN = "FORBIDDEN";
CONST.resultCode.UNSUPPORTED = "UNSUPPORTED";
CONST.resultCode.UNUSABLE = "UNUSABLE";
CONST.resultCode.SESSIONERROR = "SESSIONERROR";
CONST.resultCode.INVALID = "INVALID";
CONST.resultCode.NOT_FOUND = "NOT_FOUND";
CONST.resultCode.NOT_READY = "NOT_READY";
CONST.resultCode.NOT_NULL = "NOT_NULL";
CONST.resultCode.NOT_EQUALS = "NOT_EQUALS";
CONST.resultCode.NOT_EMPTY = "NOT_EMPTY";
CONST.resultCode.NOT_INITED = "NOT_INITED";
CONST.resultCode.NULL = "NULL";
CONST.resultCode.FULL = "FULL";
CONST.resultCode.EMPTY = "EMPTY";
CONST.resultCode.ALLOWED = "ALLOWED";
CONST.resultCode.INITED = "INITED";
CONST.resultCode.CANCEL = "CANCEL";
CONST.resultCode.ETC1 = "ETC1";
CONST.resultCode.ETC2 = "ETC2";
CONST.resultCode.ETC3 = "ETC3";
CONST.resultCode.ETC4 = "ETC4";
CONST.resultCode.ETC5 = "ETC5";

CONST.userGrade = {};
CONST.userGrade["-"] = { id: "-", userType:"-", name:"-"};
CONST.userGrade["e1"] = { id: "e1", userType: "student", name: "초1" };
CONST.userGrade["e2"] = { id: "e2", userType: "student", name: "초2" };
CONST.userGrade["e3"] = { id: "e3", userType: "student", name: "초3" };
CONST.userGrade["e4"] = { id: "e4", userType: "student", name: "초4" };
CONST.userGrade["e5"] = { id: "e5", userType: "student", name: "초5" };
CONST.userGrade["e6"] = { id: "e6", userType: "student", name: "초6" };
CONST.userGrade["m1"] = { id: "m1", userType: "student", name: "중1" };
CONST.userGrade["m2"] = { id: "m2", userType: "student", name: "중2" };
CONST.userGrade["m3"] = { id: "m3", userType: "student", name: "중3" };
CONST.userGrade["h1"] = { id: "h1", userType: "student", name: "고1" };
CONST.userGrade["h2"] = { id: "h2", userType: "student", name: "고2" };
CONST.userGrade["h3"] = { id: "h3", userType: "student", name: "고3" };

// stage map
CONST.stageMap = {};
CONST.stageMap["-"] = { id: "-", startBookImageNo: 0, endBookImageNo:0, name:"-"};
CONST.stageMap["null"] = { id: "-", matchbookImageCount: 0, endBookImageNo:0, name:"-"};
CONST.stageMap["elem"] = {id:"elem", startBookImageNo: 10001, endBookImageNo: 10003, name:"초등"};
CONST.stageMap["mid"] = { id: "mid", startBookImageNo: 20001, endBookImageNo: 20012, name:"중등"};
CONST.stageMap["high"] = { id: "high", startBookImageNo: 30001, endBookImageNo: 30010, name:"고등"};

// revise map
CONST.reviseMap = {};
CONST.reviseMap["-"] = {id:"-", name:"-"};
CONST.reviseMap["null"] = {id:"-", name:"-"};
CONST.reviseMap["2015"] = {id:"2015", name:"2015개정"};
CONST.reviseMap["2017"] = {id:"2017", name:"2017개정"};

// semester map
CONST.semesterMap = {};
CONST.semesterMap["-"] = {id:"-", name:"-"};
CONST.semesterMap["null"] = {id:"-", name:"-"};
CONST.semesterMap["s1"] = {id:"s1", name:"1학기"};
CONST.semesterMap["s2"] = {id:"s2", name:"2학기"};
CONST.semesterMap["all"] = { id: "all", name: "전체" };

// term map
CONST.termMap = {};
CONST.termMap["-"] = { id: "-", name: "-" };
CONST.termMap["null"] = { id: "-", name: "-" };
CONST.termMap["mt"] = { id: "mt", name: "중간" };		// mid term
CONST.termMap["ft"] = { id: "ft", name: "기말" };		// final term
CONST.termMap["all"] = { id: "all", name: "전체" };

// lecture level map
CONST.lectureLevelMap = {};
CONST.lectureLevelMap["-"] = { id: "-", name: "-", order: 0 };
CONST.lectureLevelMap["hintdef"] = { id: "hintdef", name: "기본힌트", order: 1 };
CONST.lectureLevelMap["hint1"] = { id: "hint1", name: "요약힌트", order: 2 };
CONST.lectureLevelMap["hint2"] = { id: "hint2", name: "상세힌트", order: 3 };
CONST.lectureLevelMap["lecdef"] = { id: "lecdef", name: "기본강의", order: 11 };
CONST.lectureLevelMap["lec1"] = { id: "lec1", name: "요약강의", order: 12 };
CONST.lectureLevelMap["lec2"] = { id: "lec2", name: "상세강의", order: 13 };
CONST.lectureLevelMap["lec9"] = { id: "lec9", name: "특별강의", order: 19 };


// exam result map
CONST.examResultMap = {};
CONST.examResultMap["-"] = { id: "-", name: "-" };
CONST.examResultMap["o"] = { id: "o", name: "정답" };
CONST.examResultMap["x"] = { id: "x", name: "오답" };
CONST.examResultMap["ho"] = { id: "ho", name: "부분정답" };
CONST.examResultMap["hx"] = { id: "hx", name: "부분오답" };
CONST.examResultMap["m"] = { id: "m", name: "채점중" };

// exam diff map
CONST.examDiffMap = {};
CONST.examDiffMap["-"] = {id:"-", name:"-"};
CONST.examDiffMap["null"] = {id:"-", name:"-"};
CONST.examDiffMap["d1"] = {id:"d1", name:"최상"};
CONST.examDiffMap["d2"] = {id:"d2", name:"상"};
CONST.examDiffMap["d3"] = {id:"d3", name:"중"};
CONST.examDiffMap["d4"] = {id:"d4", name:"하"};

// exam type map
CONST.examType = {};
CONST.examType["-"] = {id:"-", name:"-", descript:"-"};
CONST.examType["null"] = {id:"-", name:"-", descript:"-"};
CONST.examType["obj"] = { id:"obj", name:"객", descript:"객관식"};
CONST.examType["sbj"] = { id:"sbj", name:"주", descript:"주관식"};
CONST.examType["des"] = { id:"des", name:"서", descript:"서술형"};

// user status map
CONST.userStatus = {};
CONST.userStatus["-"] = { id:"-", descript: "-" };
CONST.userStatus["null"] = { id:"-", descript: "-" };
CONST.userStatus["waiting"] = { id:"waiting", descript:"승인대기중"};
CONST.userStatus["trainee"] = { id:"trainee", descript: "교육중" };
CONST.userStatus["active"] = { id:"active", descript: "사용중" };
CONST.userStatus["inactive"] = { id:"inactive", descript: "비활성화중" };
CONST.userStatus["deleted"] = { id:"deleted", descript: "삭제됨" };

// grade map
CONST.gradeMap = {};
CONST.gradeMap["-"] = {id:"-", stageId:"-", name:"-", reviseArray:[]};
CONST.gradeMap["null"] = {id:"-", stageId:"-", name:"-", reviseArray:[]};
CONST.gradeMap["e1"] = { id: "e1", stageId: "elem", name: "초1", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["e2"] = { id: "e2", stageId: "elem", name: "초2", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["e3"] = { id: "e3", stageId: "elem", name: "초3", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["e4"] = { id: "e4", stageId: "elem", name: "초4", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["e5"] = { id: "e5", stageId: "elem", name: "초5", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["e6"] = { id: "e6", stageId: "elem", name: "초6", reviseArray: [CONST.reviseMap["2015"]] };

CONST.gradeMap["m1"] = { id: "m1", stageId: "mid", name: "중1", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["m2"] = { id: "m2", stageId: "mid", name: "중2", reviseArray: [CONST.reviseMap["2017"], CONST.reviseMap["2015"]] };
CONST.gradeMap["m3"] = { id: "m3", stageId: "mid", name: "중3", reviseArray: [CONST.reviseMap["2015"]] };

CONST.gradeMap["h1"] = { id: "h1", stageId: "high", name: "고1", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["h2"] = { id: "h2", stageId: "high", name: "고2", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["h3"] = { id: "h3", stageId: "high", name: "고3", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["hs1"] = { id: "hs1", stageId: "high", name: "수1", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["hs2"] = { id: "hs2", stageId: "high", name: "수2", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["hm1"] = { id: "hm1", stageId: "high", name: "미적1", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["hm2"] = { id: "hm2", stageId: "high", name: "미적2", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["hht"] = { id: "hht", stageId: "high", name: "확통", reviseArray: [CONST.reviseMap["2015"]] };
CONST.gradeMap["hgv"] = { id: "hgv", stageId: "high", name: "기벡", reviseArray: [CONST.reviseMap["2015"]] };


// course map	※ 학년과 학기를 결합해서 id를 만든 이유: course를 선택하면 학년-학기를 얻고, 학년학기를 결합해서 id를 만들어서 빠르게 액세스한다.
CONST.courseMap = {};
CONST.courseMap["--"] = { id: "-", name: "-", stageId: "-", gradeId: "-", semesterId: "-" };
CONST.courseMap["e1s1"] = { id: "e1s1", name: "초1-1", stageId: "elem", gradeId: "e1", semesterId: "s1" };
CONST.courseMap["e1s2"] = { id: "e1s2", name: "초1-2", stageId: "elem", gradeId: "e1", semesterId: "s2" };
CONST.courseMap["e2s1"] = { id: "e2s1", name: "초2-1", stageId: "elem", gradeId: "e2", semesterId: "s1" };
CONST.courseMap["e2s2"] = { id: "e2s2", name: "초2-2", stageId: "elem", gradeId: "e2", semesterId: "s2" };
CONST.courseMap["e3s1"] = { id: "e3s1", name: "초3-1", stageId: "elem", gradeId: "e3", semesterId: "s1" };
CONST.courseMap["e3s2"] = { id: "e3s2", name: "초3-2", stageId: "elem", gradeId: "e3", semesterId: "s2" };
CONST.courseMap["e4s1"] = { id: "e4s1", name: "초4-1", stageId: "elem", gradeId: "e4", semesterId: "s1" };
CONST.courseMap["e4s2"] = { id: "e4s2", name: "초4-2", stageId: "elem", gradeId: "e4", semesterId: "s2" };
CONST.courseMap["e5s1"] = { id: "e5s1", name: "초5-1", stageId: "elem", gradeId: "e5", semesterId: "s1" };
CONST.courseMap["e5s2"] = { id: "e5s2", name: "초5-2", stageId: "elem", gradeId: "e5", semesterId: "s2" };
CONST.courseMap["e6s1"] = { id: "e6s1", name: "초6-1", stageId: "elem", gradeId: "e6", semesterId: "s1" };
CONST.courseMap["e6s2"] = { id: "e6s2", name: "초6-2", stageId: "elem", gradeId: "e6", semesterId: "s2" };
CONST.courseMap["m1s1"] = { id: "m1s1", name: "중1-1", stageId: "mid", gradeId: "m1", semesterId: "s1" };
CONST.courseMap["m1s2"] = { id: "m1s2", name: "중1-2", stageId: "mid", gradeId: "m1", semesterId: "s2" };
CONST.courseMap["m2s1"] = { id: "m2s1", name: "중2-1", stageId: "mid", gradeId: "m2", semesterId: "s1" };
CONST.courseMap["m2s2"] = { id: "m2s2", name: "중2-2", stageId: "mid", gradeId: "m2", semesterId: "s2" };
CONST.courseMap["m3s1"] = { id: "m3s1", name: "중3-1", stageId: "mid", gradeId: "m3", semesterId: "s1" };
CONST.courseMap["m3s2"] = { id: "m3s2", name: "중3-2", stageId: "mid", gradeId: "m3", semesterId: "s2" };
CONST.courseMap["h1all"] = { id: "h1all", name: "고1", stageId: "high", gradeId: "h1", semesterId: "all" };
CONST.courseMap["h2all"] = { id: "h2all", name: "고2", stageId: "high", gradeId: "h2", semesterId: "all" };
CONST.courseMap["h3all"] = { id: "h3all", name: "고3", stageId: "high", gradeId: "h3", semesterId: "all" };
CONST.courseMap["hs1all"] = { id: "hs1all", name: "수1", stageId: "high", gradeId: "hs1", semesterId: "all" };
CONST.courseMap["hs2all"] = { id: "hs2all", name: "수2", stageId: "high", gradeId: "hs2", semesterId: "all" };
CONST.courseMap["hm1all"] = { id: "hm1all", name: "미적1", stageId: "high", gradeId: "hm1", semesterId: "all" };
CONST.courseMap["hm2all"] = { id: "hm2all", name: "미적2", stageId: "high", gradeId: "hm2", semesterId: "all" };
CONST.courseMap["hhtall"] = { id: "hhtall", name: "확통", stageId: "high", gradeId: "hht", semesterId: "all" };
CONST.courseMap["hgvall"] = { id: "hgvall", name: "기벡", stageId: "high", gradeId: "hgv", semesterId: "all" };







CONST.contentsType = {};
CONST.contentsType["exam"] = { id:"exam", name:"문제" };
CONST.contentsType["concept"] = { id:"concept", name:"개념" };

CONST.patType = {}
CONST.patType["base"] = { id: "base", name: "기본" };
CONST.patType["app"] = { id: "app", name: "응용" };
CONST.patType["adv"] = { id: "adv", name: "심화" };


CONST.studyType = {};
CONST.studyType["mb-sdy"] = { id: "mb-sdy", name:"매칭북 학습", shortName:"매북", no:"1"};
CONST.studyType["exam-sdy"] = { id:"exam-sdy", name:"문제지 풀기", shortName:"확인", no:"2"};
CONST.studyType["pat-sdy"] = { id:"pat-sdy", name:"유형 학습", shortName:"유형", no:"3"};
CONST.studyType["mp-sdy"] = { id: "mp-sdy", name:"매칭기출 학습", shortName:"기출", no:"4"};
CONST.studyType["sb-sdy"] = { id: "sb-sdy", name: "스마트북 학습", shortName: "스북", no: "5" };
CONST.studyType["le-sdy"] = { id: "le-sdy", name: "문항강의 학습", shortName: "강의", no: "6" };
CONST.studyType["cli-sdy"] = { id: "cli-sdy", name: "클리닉 학습", shortName: "클리닉", no: "7" };
CONST.studyType["mb-put"] = { id: "mb-put", name: "매칭북 숙제", shortName: "매북", no: "8" };
CONST.studyType["exam-put"] = { id: "exam-put", name: "문제지 숙제", shortName: "확인", no: "9" };
CONST.studyType["pat-put"] = { id: "pat-put", name: "유형학습 숙제", shortName: "유형", no: "10" };
CONST.studyType["mp-put"] = { id: "mp-put", name: "매칭기출 숙제", shortName: "기출", no: "11" };
CONST.studyType["sb-put"] = { id: "sb-put", name: "스마트북 숙제", shortName: "스북", no: "12" };
CONST.studyType["le-put"] = { id: "le-put", name: "문항강의 숙제", shortName: "강의", no: "13" };
CONST.studyType["plan-sdy"] = { id: "plan-sdy", name: "플래너 학습", shortName: "플래너", no: "14" };

CONST.studyResultStatus = {};
CONST.studyResultStatus["puted"] = { id: "puted", name: "출제됨" };
CONST.studyResultStatus["marking"] = { id: "marking", name: "채점중" };
CONST.studyResultStatus["complete"] = { id: "complete", name: "채점완료" };

CONST.weekDay = {};
CONST.weekDay["sun"] = {id:"sun", name:"일요일"};
CONST.weekDay["mon"] = {id:"mon", name:"월요일"};
CONST.weekDay["tue"] = {id:"tue", name:"화요일"};
CONST.weekDay["wed"] = {id:"wed", name:"수요일"};
CONST.weekDay["thu"] = {id:"thu", name:"목요일"};
CONST.weekDay["fri"] = {id:"fri", name:"금요일"};
CONST.weekDay["sat"] = {id:"sat", name:"토요일"};

CONST.totalDiff = {};
CONST.totalDiff["-"] = { id: "-", name: "-", ratio: 100.0 };
CONST.totalDiff["hh"] = { id: "hh", name: "상상", ratio: 3.7 };
CONST.totalDiff["hl"] = { id: "hl", name: "상하", ratio: 2.8 };
CONST.totalDiff["mh"] = { id: "mh", name: "중상", ratio: 2.4 };
CONST.totalDiff["mm"] = { id: "mm", name: "중중", ratio: 1.9 };
CONST.totalDiff["ml"] = { id: "ml", name: "중하", ratio: 1.6 };
CONST.totalDiff["lh"] = { id: "lh", name: "하상", ratio: 1.3 };
CONST.totalDiff["ll"] = { id: "ll", name: "하하", ratio: 1.0 };


CONST.reportType = {};
CONST.reportType["-"] = { id: "-", isTotalReport: false, name: "-" };
CONST.reportType["scorept"] = { id: "scorept", isTotalReport: false, name: "간단 학습결과지" };
CONST.reportType["analyrpt"] = { id: "analyrpt", isTotalReport: false, name: "학습결과 분석지" };
CONST.reportType["monthlyrpt"] = { id: "monthlyrpt", isTotalReport: true, name: "월간 학습 종합보고서" };
CONST.reportType["wholerpt"] = { id: "wholerpt", isTotalReport: true, name: "재원기간 학습 종합보고서" };


CONST.csType = {};
CONST.csType["-"] = { id: "-", name: "-" };
CONST.csType["lecerr"] = { id: "lecerr", name: "강의 오류" };
CONST.csType["exerr"] = { id: "exerr", name: "문제 오류" };
CONST.csType["anserr"] = { id: "anserr", name: "답안 오류" };
CONST.csType["typerr"] = { id: "typerr", name: "오타 있음" };
CONST.csType["unierr"] = { id: "unierr", name: "단원분류 잘못됨" };
CONST.csType["paterr"] = { id: "paterr", name: "유형분류 잘못됨" };
CONST.csType["diferr"] = { id: "diferr", name: "난이도 부적절" };
CONST.csType["duperr"] = { id: "duperr", name: "중복 문제" };
CONST.csType["corerr"] = { id: "corerr", name: "교과과정 분류 잘못됨" };
CONST.csType["etcerr"] = { id: "etcerr", name: "그외 기타" };

CONST.csStatus = {};
CONST.csStatus["-"] = { id: "-", name: "-" };
CONST.csStatus["writed"] = { id: "writed", name: "작성됨" };
CONST.csStatus["inprogress"] = { id: "inprogress", name: "처리중" };
CONST.csStatus["hold"] = { id: "hold", name: "보류중" };
CONST.csStatus["sendback"] = { id: "sendback", name: "반송됨" };
CONST.csStatus["complete"] = { id: "complete", name: "처리완료" };

//product
CONST.productType = {};
CONST.productType["book"] = { id: "book", name: "교재", shipPrice: 4000 };
CONST.productType["article"] = { id: "article", name: "물품", shipPrice: 4000 };
CONST.productType["online"] = { id: "online", name: "온라인학습권", shipPrice: 0 };

//order status
CONST.orderStatus = {};
CONST.orderStatus["unpaid"] = { id: "unpaid", name: "미결제" };
CONST.orderStatus["paying"] = { id: "paying", name: "결제중" };
CONST.orderStatus["paid"] = { id: "paid", name: "결제완료" };
	
//iniPay 지불 수단별 URL
CONST.iniPayMethod = {};
CONST.iniPayMethod["CARD"] = { url: "/smart/payment/", name: "신용카드" };
CONST.iniPayMethod["MOBILE"] = { url: "/smart/payment/", name: "휴대폰" };
CONST.iniPayMethod["BANK"] = { url: "/smart/payment/", name: "계좌이체" };
CONST.iniPayMethod["VBANK"] = { url: "/smart/payment/", name: "가상계좌" };
CONST.iniPayMethod["CULTURE"] = { url: "/smart/culture/", name: "문화상품권" };
CONST.iniPayMethod["HPMN"] = { url: "/smart/hpmn/", name: "해피머니" };
CONST.iniPayMethod["DGCL"] = { url: "/smart/dgcl/", name: "스마트문상" };

//planner
CONST.studyStepType = {};
CONST.studyStepType["review-sdy"] = { id:"review-sdy", name: "복습"};
CONST.studyStepType["unit-sdy"] = { id: "unit-sdy", name: "학습"};
CONST.studyStepType["complete-unit-sdy"] = { id: "complete-unit-sdy", name: "학습 완료" };
CONST.studyStepType["lecture-sdy"] = { id: "lecture-sdy", name: "개념강의 학습"};
CONST.studyStepType["clinic-first-sdy"] = { id: "clinic-first-sdy", name: "1차 클리닉 학습"};
CONST.studyStepType["clinic-second-sdy"] = { id: "clinic-second-sdy", name: "2차 클리닉 학습"};
CONST.studyStepType["complete-total-sdy"] = { id: "complete-total-sdy", name: "종합 학습 완료"};


CONST.subNoTypeArray = [
	["1", "2", "3", "4", "5", "6", "7", "8", "9", "10",
		"11", "12", "13", "14", "15", "16", "17", "18", "19", "20"],

	["(1)", "(2)", "(3)", "(4)", "(5)", "(6)", "(7)", "(8)", "(9)", "(10)",
		"(11)", "(12)", "(13)", "(14)", "(15)", "(16)", "(17)", "(18)", "(19)", "(20)"],

	["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩",
		"⑪", "⑫", "⑬", "⑭", "⑮", "⑯", "⑰", "⑱", "⑲", "⑳"],

	["a", "b", "c", "d", "e", "f", "g", "h", "i", "j",
		"k", "l", "m", "n", "o", "p", "q", "r", "s", "t"],

	["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)", "(i)", "(j)",
		"(k)", "(l)", "(m)", "(n)", "(o)", "(p)", "(q)", "(r)", "(s)", "(t)"],

	["ⓐ", "ⓑ", "ⓒ", "ⓓ", "ⓔ", "ⓕ", "ⓖ", "ⓗ", "ⓘ", "ⓙ",
		"ⓚ", "ⓛ", "ⓜ", "ⓝ", "ⓞ", "ⓟ", "ⓠ", "ⓡ", "ⓢ", "ⓣ"],

	["A", "B", "C", "D", "E", "F", "G", "H", "I", "J",
		"K", "L", "M", "N", "O", "P", "Q", "R", "S", "T"],

	["(A)", "(B)", "(C)", "(D)", "(E)", "(F)", "(G)", "(H)", "(I)", "(J)",
		"(K)", "(L)", "(M)", "(N)", "(O)", "(P)", "(Q)", "(R)", "(S)", "(T)"],

	["ㄱ", "ㄴ", "ㄷ", "ㄹ", "ㅁ", "ㅂ", "ㅅ", "ㅇ", "ㅈ", "ㅊ",
		"ㅋ", "ㅌ", "ㅍ", "ㅎ"],

	["(ㄱ)", "(ㄴ)", "(ㄷ)", "(ㄹ)", "(ㅁ)", "(ㅂ)", "(ㅅ)", "(ㅇ)", "(ㅈ)", "(ㅊ)",
		"(ㅋ)", "(ㅌ)", "(ㅍ)", "(ㅎ)"],

	["㉠", "㉡", "㉢", "㉣", "㉤", "㉥", "㉦", "㉧", "㉨", "㉩",
		"㉪", "㉫", "㉬", "㉭"],

	["가", "나", "다", "라", "마", "바", "사", "아", "자", "차",
		"카", "타", "파", "하"],

	["(가)", "(나)", "(다)", "(라)", "(마)", "(바)", "(사)", "(아)", "(자)", "(차)",
		"(카)", "(타)", "(파)", "(하)"]
];

export default CONST;